jQuery(function($){

	$('html').removeClass('no-js');




	// PRELOADER
	$(window).load(function() {
		$('#page_preloader').delay(700).fadeOut(700);

		function preloaderRemove() {
			$('#page_preloader').remove()
		};

		setTimeout( preloaderRemove, 3000 );
	});




	// IOS HOVER
	if ((navigator.userAgent.match(/iPhone/i)) || (navigator.userAgent.match(/iPod/i)) || (navigator.userAgent.match(/iPad/i))) {
		$('a').on("touchstart", function() {});
	};




	// HZ
	$('ul.styles > li').click(function(){
		var className = $(this).attr('class');
		$('body').removeClass('theme-style-0 theme-style-1 theme-style-2 theme-style-3');
		$('body').addClass(className);
	});




	// PLACEHOLDER JS
	$('[placeholder]').each(function(){
	  if ($(this).val() === '') {
		var hint = $(this).attr('placeholder');
		$(this).val(hint).addClass('hint');
	  }
	});

	$('[placeholder]').focus(function() {
	  if ($(this).val() === $(this).attr('placeholder')) {
		$(this).val('').removeClass('hint');
	  }
	}).blur(function() {
	  if ($(this).val() === '') {
		$(this).val($(this).attr('placeholder')).addClass('hint');
	  }
	});




	// FORM VALIDATION MINI
	$.fn.formValidation=function(){this.find("input, textarea").after('<p class="alert-form-info"></p>'),this.on("submit",function(t){if($(this).find("input, textarea").each(function(){""==$(this).val()&&($(this).addClass("alert-form").next().html("Field can&#39;t be blank").slideDown(),$(this).on("focus",function(){$(this).removeClass("alert-form").next().slideUp()}),t.preventDefault())}),$(this).find("input[type=email]").length){var e=$(this).find("input[type=email]");e.val().length>0&&(e.val().length<6||-1==e.val().indexOf("@")||-1==e.val().indexOf("."))&&(e.addClass("alert-form").next().html("Incorrect email").slideDown(),e.on("focus",function(){$(this).removeClass("alert-form").next().slideUp()}),t.preventDefault())}if(2==$(this).find("input[type=password]").length){var n=$(this).find("input[type=password]:eq(0)"),i=$(this).find("input[type=password]:eq(1)");n.val()!=i.val()&&(i.addClass("alert-form").next().html("Passwords do not match").slideDown(),i.on("focus",function(){i.removeClass("alert-form").next().slideUp()}),t.preventDefault())}})};




	// FORM STYLES
	$('.address_table form, .customer_address form').addClass('form-horizontal');




	// CUSTOM SELECTS
	$('.header_currency select, #navigation select').styler();
	$('.jq-selectbox__trigger').append('<i class="fa fa-angle-down"></i>');




	// MEGAMENU DESKTOP
	$('.sf-menu').superfish({
		animation: {height: 'show'},
		speed: 'fast'
	});

	var path = window.location.pathname.split('/');
	path = path[path.length-1];
	if (path !== undefined) {
	  $("ul.sf-menu > li").children("a[href$='" + path + "']").parents('li').children('a').addClass('active');
	};

	var path2 = window.location.pathname;
	if (path2 == '/' || path == undefined) {
	  $("ul.sf-menu > li").children("a[href$='" + path2 + "']").parents('li').children('a').addClass('active');
	};




	// MEGAMENU MOBILE
	$(document).ready(function(){
		$(".megamenu_mobile h2").click(function(){
			$(".level_1").slideToggle("slow");
			$(this).toggleClass("active");
		});

		$(".level_1_trigger").click(function(){
			$(this).parent().parent().find(".level_2").slideToggle("slow");
			$(this).toggleClass("active");
			return false;
		});

		$(".level_2_trigger").click(function(){
			$(this).parent().parent().find(".level_3").slideToggle("slow");
			$(this).toggleClass("active");
			return false;
		});

		$('.megamenu_mobile h2').on('click touchstart', function(e){
			e.stopPropagation();
		});

		$(document).on('click', function(){
			$(".level_1").slideUp("slow");
			$(".megamenu_mobile").find("h2").removeClass("active");
		});
	});




	// STICK MENU
	$(window).on('load', function() {
		$('#megamenu').tmStickUp();
	});




	// MAIN PRODUCT LISTING IMAGE CHANGE
	imgChange = function (){
		if ( device.desktop() ) {
			$(document).on({
			    mouseenter: function(){
			        $(this).find(".img__2").stop().animate({"opacity": 1});
			        $(this).find(".img__1").stop().animate({"opacity": 0});
			    },
			    mouseleave: function(){
			        $(this).find(".img__2").stop().animate({"opacity": 0});
			        $(this).find(".img__1").stop().animate({"opacity": 1});
			    }
			}, '.img_change');
		};
	};
	$(window).load( imgChange );




	// BACK TO TOP BUTTON
	$(document).ready(function(){
		$(document.body).append('<a id="back_top" title="Back to top" href="#"></a>');
		$('#back_top').hide();

		$(window).scroll(function(){
			if ( $(this).scrollTop() > 300 ) {
				$('#back_top').fadeIn("slow");
			}
			else {
				$('#back_top').fadeOut("slow");
			};
		});

		$('#back_top').on('click', function(e) {
			e.preventDefault();
			$('html, body').animate({scrollTop : 0},800);
			$('#back_top').fadeOut("slow").stop();
		});
	});




	// PRODUCT QUANTITY FORM MINI, USED ON:
	// 1. PRODUCT PAGE
	// 2. PRODUCT QUICK VIEW
	// 3. CART PAGE
	$(document).on("focusout",".quantity_input",function(){var t=$(this).val();$(this).val(isNaN(parseFloat(t))&&!isFinite(t)||0==parseInt(t)||""==t?1:parseInt(t)<0?parseInt(t)-2*parseInt(t):parseInt(t))}),$(document).on("click",".quantity_up",function(){var t=$(this).parent().find(".quantity_input");t.val(!isNaN(parseFloat(t.val()))&&isFinite(t.val())?parseInt(t.val())+1:1)}),$(document).on("click",".quantity_down",function(){var t=$(this).parent().find(".quantity_input");t.val(!isNaN(parseFloat(t.val()))&&isFinite(t.val())&&t.val()>1?parseInt(t.val())-1:1)});




	// HOMEPAGEW PRODUCTS CAROUSEL CONTROLS
	$(window).on('load resize', function(){
		var titleHeight = -$('.featured_products h2').height()/2;
		$('.featured_products .bx-controls').css({ 'top' : titleHeight });
	});




	// add to cart disabled message
	$('#add-to-cart').on('click', function(e){
		if ($(this).hasClass('disabled')) {
			e.preventDefault();
			e.stopPropagation();
			$('.purchase-helper').removeClass('hide');
		}
		else {
			$('.purchase-helper').addClass('hide');
		}
	});


	// collection pages
	// equalize product tile heights
	function equalizeGrid($parent, selector, numInRow) {
		var $block = $parent.find(selector),
			windowWidth = window.innerWidth;

		// remove the equalization heights
		$block.each(function(index){
			$(this).removeAttr('style');
		});

		// equalize the grid heights
		var maxHeight = [];
		for (var i=0; i<($block.length / numInRow); i++) {
			maxHeight[i] = 0;
		}
		$block.each(function(index){
			var height = $(this).outerHeight(),
				row = Math.floor(index / numInRow);
			if (height > maxHeight[row]) {
				maxHeight[row] = height;
			}
		});
		$block.each(function(index){
			$(this).outerHeight(maxHeight[Math.floor(index / numInRow)]);
		});
	}

	var $images = $('.product_listing_main img'),
			counter = 0;

	$images.each(function(){
		$(this).on('load error', function (){
			counter++;
			if (counter === $images.length) {
				// equalize product image
				equalizeGrid($('.product_listing_main'), '.product_img', 4);

				// equalize product info
				equalizeGrid($('.product_listing_main'), '.product_info', 4)
			}
		});
		if (this.complete) {
			counter++;
			if (counter === $images.length) {
				// equalize product image
				equalizeGrid($('.product_listing_main'), '.product_img', 4);

				// equalize product info
				equalizeGrid($('.product_listing_main'), '.product_info', 4)
			}
		}
		else {
			// ie11 bug fix - reset the image src so IE11 fires the load/error events and equalize is triggered
			if (navigator.userAgent.indexOf('MSIE')!==-1 || navigator.appVersion.indexOf('Trident/') > 0) {
				var srcAttr = this.src;
				this.src = srcAttr;
			}
		}
	});

	var $collectionImages = $('.collection_listing_main img'),
			collectionCounter = 0;

	$collectionImages.each(function(){
		$(this).on('load error', function (){
			collectionCounter++;
			if (collectionCounter === $collectionImages.length) {
				// equalize collection image
				equalizeGrid($('.collection_listing_main'), '.collection_img', 4);

				// equalize collection info
				equalizeGrid($('.collection_listing_main'), '.collection_info', 4)
			}
		});
		if (this.complete) {
			collectionCounter++;
			if (collectionCounter === $images.length) {
				// equalize collection image
				equalizeGrid($('.collection_listing_main'), '.collection_img', 4);

				// equalize collection info
				equalizeGrid($('.collection_listing_main'), '.collection_info', 4)
			}
		}
		else {
			// ie11 bug fix - reset the image src so IE11 fires the load/error events and equalize is triggered
			if (navigator.userAgent.indexOf('MSIE')!==-1 || navigator.appVersion.indexOf('Trident/') > 0) {
				var srcAttr = this.src;
				this.src = srcAttr;
			}
		}
	});

});
